'use strict'
import moment from 'moment'
import _ from 'lodash'
import * as dot from 'dot-object'
import magazzinoService from '@/services/magazzinoService.js'
import movimentiService from '@/services/movimentiService.js'
import documenti from '@/services/documentiService.js'
import { sanitize } from '@/helpers/sanitize'
import configurazioni from '@/services/configurazioniService'
import prodottiService from '@/services/prodottiService'

/* async function importaDaModello(modello, periodo) {
  var dati
  var ids
  switch(modello.tipoDati) {
    case 'scontrini':
      ({ dati, ids } = await esportaScontrini(modello, periodo))
    case 'fatture':
      break
    case 'ordini':
      break
    default:
      break
  }
  return {
    dati,
    tipo: modello.tipoDati,
    ids
  }
} */

async function leggeFile(nomeFile, modello) {
  var config
  switch(modello.file.sorgente) {
    case 'file':
      config = { ...modello.file, nomeFile: parseNomeFile(nomeFile) }
      return await documenti.leggeFileLocale(config)          
    case 'ftp':
      config = { ...modello.ftp, ...modello.file, nomeFile: parseNomeFile(nomeFile) }
      return await documenti.leggeFtp(config)
    default:
      break
  }
}

const parseNomeFile = (nomeFile) => {
  let nome = nomeFile
  nome = nome.replace('#yyyy#', String(moment().year()))
  nome = nome.replace('#yy#', String(moment().year()).substring(2))
  nome = nome.replace('#mm#', String(moment().month() + 1).padStart(2, '0'))
  nome = nome.replace('#dd#', String(moment().date()).padStart(2, '0'))
  return nome
}

async function eliminaFile(file, modello) {
  switch(modello.file.sorgente) {
    case 'file':
      return await documenti.eliminaFileLocale(file) 
    case 'ftp':
      const config = { ...modello.ftp, file }
      return await documenti.eliminaFileFtp(config)
    default:
      break
  }      
}

async function generaMovimenti(modelloItem, dati, datiProdotti) {
  // TODO: Generalizzare. Per adesso modello Geoform, TES + nRIG
  // cicla su tutti i movimenti. Se incontra la testata --> cambia il riferimento, poi crea movimenti (array) con prodotti su dettaglio righe, poi batch
  let riferimentoId = ''
  let riferimentoData = ''
  let riferimentoTipo = ''
  let dataTestata = null
  let movimentiDaCreare = false
  const causali = await configurazioni.getConfigurazione('magazzino_causali', 'causali')
  const causale = causali.find(el => el.codice === modelloItem.causaleMovimento)
  let magazzino = 'mag01'
  let righe = []
  for (let riga of dati) {
    const items = riga.split(modelloItem.file.separatore || ';')
    if (items[0] === 'TES') {
      if (movimentiDaCreare) {
        movimentiDaCreare = false
        const esistenti = await movimentiService.getMovimentiPerRiferimento(riferimentoTipo, riferimentoId)
        if (esistenti.length === 0 || modelloItem.consentiRiferimentoEsistente) {
          const base = {
            magazzino: magazzino,
            tipoCausale: causale.tipo,
            causale: causale.codice,
            data: dataTestata || new Date(),
            riferimentoId: riferimentoId || causaleMovimento,
            riferimentoData: riferimentoData,
            riferimentoTipo: riferimentoTipo,
            mostraCliente: false,
            mostraFornitore: false,
            tipoPrezzo: causale.tipoPrezzo
          }
          const movimentiMultipli = await buildMovimentiMultipli(righe, base, modelloItem, datiProdotti)
          await magazzinoService.creaMovimentiMultipli(movimentiMultipli)
        }
      }
      righe = []
      dataTestata = moment(getValoreItem(items, modelloItem.testata, 'data'), 'DD/MM/YYYY').toDate()
      riferimentoTipo = getValoreItem(items, modelloItem.testata, 'riferimento.tipo')
      riferimentoId = getValoreItem(items, modelloItem.testata, 'riferimento.id')
      riferimentoData = moment(getValoreItem(items, modelloItem.testata, 'riferimento.data'), 'DD/MM/YYYY').toDate()
      // leggere magazzino ...
    } else {
      const data = moment(getValoreItem(items, modelloItem.dettaglio, 'data'), 'DD/MM/YYYY').toDate()
      const codiceArticolo = getValoreItem(items, modelloItem.dettaglio, 'prodotto.codice')
      const quantita = +parseFloat(getValoreItem(items, modelloItem.dettaglio, 'quantita')).toFixed(2)
      const valore = +parseFloat(getValoreItem(items, modelloItem.dettaglio, 'valore')).toFixed(2)
      righe.push({
        quantita,
        codice: codiceArticolo,
        valore,
        data
      })
      movimentiDaCreare = true
    }
  }
  if (movimentiDaCreare) {
    movimentiDaCreare = false
    const esistenti = await movimentiService.getMovimentiPerRiferimento(riferimentoTipo, riferimentoId)
    if (esistenti.length === 0 || modelloItem.consentiRiferimentoEsistente) {
      const base = {
        magazzino: magazzino,
        tipoCausale: causale.tipo,
        causale: causale.codice,
        data: dataTestata || new Date(),
        riferimentoId: riferimentoId || causaleMovimento,
        riferimentoData: riferimentoData,
        riferimentoTipo: riferimentoTipo,
        mostraCliente: false,
        mostraFornitore: false,
        tipoPrezzo: causale.tipoPrezzo
      }
      const movimentiMultipli = await buildMovimentiMultipli(righe, base, modelloItem, datiProdotti)
      await magazzinoService.creaMovimentiMultipli(movimentiMultipli)
    }
  }
  return { status: 'ok' }
} 

const getValoreItem = (items, modelloItem, destinazione) => {
  let valore = ''
  let item = modelloItem.find(x => x.destinazione === destinazione)
  if (item) {
    const idx = modelloItem.indexOf(item)
    valore = items[idx]
  }
  return valore
}

const buildMovimentiMultipli = async function(righeCarrello, base, modello, datiProdotti) {
  const prodottiInseriti = righeCarrello
  const ids = _.uniq(prodottiInseriti.map(x => x.codice))
// TODO: Se i prodotti non esistono devono essere creati prima !!
  var prodotti = await prodottiService.getProdottiByIds(ids)
  // var prodottiNonTrovati = datiProdotti.filter(x => !ids.includes(x.codice))
  const codiciEsistenti = prodotti.map(x => x.codice)
  var prodottiNonTrovati = datiProdotti.filter(x => !codiciEsistenti.includes(x[0]))
  if (prodottiNonTrovati.length > 0) {
    await creaProdottiMancanti(prodottiNonTrovati, modello)
    // Rilegge i dati per considerare anche i nuovi creati
    prodotti = await prodottiService.getProdottiByIds(ids)
  }
  const movimenti = prodottiInseriti.map(el => {
    const quantita = el.quantita
    const prodotto = prodotti.find(x => x._id === el.codice)
    if (!prodotto || !prodotto._id) {
      console.log('Articolo non trovato per codice: ', el.codice)
    } else {
      const nM = {
        magazzino: base.magazzino,
        tipo: base.tipoCausale,
        causale: base.causale,
        data: base.data,
        prodotto: {
          codice: prodotto._id,
          um: _.get(prodotto, 'magazzino.unitaMisura', '') || 'n'
        },
        anagrafica: {},
        riferimento: {
          tipo: base.riferimentoTipo,
          id: base.riferimentoId,
          data: base.riferimentoData
        }
      }
      if (base.mostraCliente && base.nominativo) {
        nM.anagrafica.cliente = {
          codice: base.nominativo,
          descrizione: base.nominativoDescrizione
        }
      }
      if (base.mostraFornitore && base.nominativo) {
        nM.anagrafica.fornitore = {
          codice: base.nominativo,
          descrizione: base.nominativoDescrizione
        }
      }
      nM.quantita = +parseFloat(quantita).toFixed(2)
      if (base.tipoPrezzo === 'acquisto') {
        nM.valore = +el.valore.toFixed(2) || +(parseFloat(_.get(prodotto, 'magazzino.prezzoAcquisto', 0) || 0) * nM.quantita).toFixed(2)
      } else {
        nM.valore = +el.valore.toFixed(2) || +((parseFloat(el.prezzoUnitario) || parseFloat(_.get(prodotto, 'prezzo.L1.base', 0))) * nM.quantita).toFixed(2)
      }
      return nM
    }
  })
  // toglie i movimenti non creati per mancanza di prodotto
  return movimenti.filter(x => x)
}

const creaProdottiMancanti = async (dati, modello) => {
  const aliquoteIva = await configurazioni.getConfigurazione('prodotti_aliquote_iva', 'aliquote')
  const repartiFiscali = await configurazioni.getConfigurazione('prodotti_reparti_fiscali', 'reparti')
  const modelloItem = modello.prodotti
  let righe = []
  for (let items of dati) {
    let pp = {}
    for (let item of modelloItem) {
      _.set(pp, item.destinazione, getValoreItem(items, modelloItem, item.destinazione)) 
    }
    righe.push(pp)
  }
  const daCreare = righe.map(pr => {
    const pobj = dot.object({ ...pr })
    pobj.codice = sanitize(pobj.codice)
    pobj.marchio = sanitize(pobj.marchio)
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `varianti.variante${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `varianti.variante${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `varianti.variante${c}.codice`, c_codice)
        _.set(pobj, `varianti.variante${c}.descrizione`, c_desc)
      }
    }
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `statistici.categoria${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `statistici.categoria${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `statistici.categoria${c}.codice`, c_codice)
        _.set(pobj, `statistici.categoria${c}.descrizione`, c_desc)
      }
    }
    let iva = aliquoteIva.find(x => String(x.codice) === String(pobj.appoggio.aliquota))
    let reparto = repartiFiscali.find(x => String(x.codice).toUpperCase() === String(pobj.appoggio.repartoFiscale).toUpperCase() || String(x.stampante.numero).toUpperCase() === String(pobj.appoggio.repartoFiscale))
    if (pobj.appoggio.azienda) {
      reparto = repartiFiscali.find(x => x.stampante.azienda === pobj.appoggio.azienda && (String(x.codice).toUpperCase() === String(pobj.appoggio.repartoFiscale).toUpperCase() || String(x.stampante.numero).toUpperCase() === String(pobj.appoggio.repartoFiscale)))
    }
    delete pobj.appoggio // toglie tutti i dati che non devono andare nel db prodotti
    _.merge(pobj, modello.datiDefault)
    if (iva && reparto) {
      delete pobj.datiFiscali
      pobj.datiFiscali = {
        aliquoteIva: [{
          codice: iva.codice,
          valore: iva.aliquota,
          descrizione: iva.descrizione,
          tipoApplicazione: 'banco' // eventualmente passare
        }],
        reparto: {
          codice: reparto.codice,
          descrizione: reparto.descrizione,
          stampante: reparto.stampante.numero
        }
      }
    }
    if (pobj.magazzino.prezzoAcquisto) {
      pobj.magazzino.prezzoAcquisto = +parseFloat(pobj.magazzino.prezzoAcquisto).toFixed(2)
    }

    pobj.magazzino.unitaMisura = pobj.magazzino.unitaMisura || 'n'

    if (pobj.prezzo.L1 && pobj.prezzo.L1.base) pobj.prezzo.L1.base = +parseFloat(pobj.prezzo.L1.base).toFixed(2)
    if (pobj.prezzo.L2 && pobj.prezzo.L2.base) pobj.prezzo.L2.base = +parseFloat(pobj.prezzo.L2.base).toFixed(2)
    if (pobj.prezzo.L3 && pobj.prezzo.L3.base) pobj.prezzo.L3.base = +parseFloat(pobj.prezzo.L3.base).toFixed(2)
    if (pobj.prezzo.L4 && pobj.prezzo.L4.base) pobj.prezzo.L4.base = +parseFloat(pobj.prezzo.L4.base).toFixed(2)
    if (pobj.prezzo.L5 && pobj.prezzo.L5.base) pobj.prezzo.L5.base = +parseFloat(pobj.prezzo.L5.base).toFixed(2)

    delete pobj.codiceFornitore
    return pobj
  })
  let aggiornaProdotti = true // usato per debug --> se false esclude la creazione dei prodotti
  if (aggiornaProdotti && daCreare && daCreare.length > 0) {
    let start = 0
    let end = 0
    do {
      end = start + 5000
      const sub = daCreare.slice(start, end)
      console.log('prodotti:', start, end)
      const usaTagliaColore = false // TODO: Verificare come prendere dal modello
      await prodottiService.creaProdottiMultipliTestBarcode(sub, 'import automatico', usaTagliaColore, false)

      start += 5000
    } while (end < daCreare.length)
  }
}

export default {
  leggeFile,
  eliminaFile,
  generaMovimenti
}
